// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.neuron-map-page {
  width: 100%;
  min-height: 860px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 420px;
  gap: 22px;
  padding: 20px;
  border-radius: 28px;
  color: #f8fafc;
  overflow: hidden;
  background:
    radial-gradient(circle at 24% 28%, rgba(92, 72, 255, 0.24), transparent 28%),
    radial-gradient(circle at 66% 44%, rgba(14, 165, 233, 0.12), transparent 26%),
    linear-gradient(135deg, #050b18 0%, #081122 42%, #0d1628 100%);
  border: 1px solid rgba(148, 163, 184, 0.18);
  box-shadow: 0 30px 90px rgba(2, 6, 23, 0.28);
}

.neuron-main-panel {
  min-width: 0;
  position: relative;
}

.neuron-map-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
}

.neuron-map-header h2 {
  margin: 0;
  font-size: 30px;
  line-height: 1.05;
  font-weight: 950;
  letter-spacing: -0.04em;
  color: #ffffff;
  text-shadow: 0 0 28px rgba(255, 255, 255, 0.1);
}

.neuron-map-header p {
  margin: 7px 0 0;
  color: #cbd5e1;
  font-size: 14px;
}

.neuron-help {
  display: grid;
  gap: 8px;
  padding: 14px 16px;
  border-radius: 16px;
  background: rgba(15, 23, 42, 0.64);
  border: 1px solid rgba(148, 163, 184, 0.24);
  color: #cbd5e1;
  font-size: 13px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 18px 42px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(18px);
}

.neuron-mode-toggle {
  display: inline-flex;
  gap: 8px;
  padding: 4px;
  margin-top: 20px;
  border-radius: 17px;
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: 0 18px 55px rgba(0, 0, 0, 0.18);
}

.neuron-mode-toggle button {
  border: 0;
  border-radius: 13px;
  padding: 12px 20px;
  background: transparent;
  color: #cbd5e1;
  font-weight: 900;
  cursor: pointer;
  transition: transform 0.18s ease, background 0.18s ease, color 0.18s ease;
}

.neuron-mode-toggle button:hover {
  transform: translateY(-1px);
  color: #ffffff;
}

.neuron-mode-toggle button.active {
  background: linear-gradient(135deg, #5b5ff7 0%, #7c3aed 100%);
  color: #ffffff;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.16), 0 14px 36px rgba(124, 58, 237, 0.42);
}

.neuron-canvas-shell {
  height: 720px;
  margin-top: 16px;
  border-radius: 24px;
  overflow: hidden;
  background:
    radial-gradient(circle at 50% 44%, rgba(77, 70, 229, 0.2), transparent 38%),
    radial-gradient(circle at 75% 35%, rgba(14, 165, 233, 0.1), transparent 30%),
    #020612;
  border: 1px solid rgba(148, 163, 184, 0.18);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 22px 65px rgba(0, 0, 0, 0.28);
}

.neuron-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 16px;
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.16);
}

.neuron-legend button {
  border: 0;
  background: transparent;
  color: #e5e7eb;
  font-weight: 800;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 2px 0;
}

.neuron-legend i,
.neuron-region-grid i,
.neuron-selected-head i {
  width: 14px;
  height: 14px;
  display: inline-block;
  border-radius: 999px;
  box-shadow: 0 0 18px currentColor, 0 0 30px currentColor;
  flex: 0 0 auto;
}

.neuron-side-panel {
  min-width: 0;
  display: grid;
  gap: 16px;
  align-content: start;
}

.neuron-side-card {
  padding: 18px;
  border-radius: 22px;
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 24px 70px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(20px);
}

.neuron-side-card h3 {
  margin: 0 0 14px;
  font-size: 17px;
  font-weight: 950;
  color: #ffffff;
  letter-spacing: -0.02em;
}

.neuron-region-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.neuron-region-grid button {
  text-align: left;
  border: 1px solid rgba(148, 163, 184, 0.2);
  background: linear-gradient(135deg, rgba(30, 41, 59, 0.78), rgba(15, 23, 42, 0.72));
  color: #f8fafc;
  border-radius: 14px;
  padding: 12px;
  cursor: pointer;
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 9px;
  row-gap: 3px;
  align-items: center;
  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.neuron-region-grid button:hover {
  transform: translateY(-1px);
  border-color: rgba(226, 232, 240, 0.34);
}

.neuron-region-grid button.active {
  border-color: rgba(124, 58, 237, 0.96);
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.16), 0 0 34px rgba(124, 58, 237, 0.18);
}

.neuron-region-grid strong {
  font-size: 13px;
  color: #ffffff;
}

.neuron-region-grid span {
  grid-column: 2;
  color: #cbd5e1;
  font-size: 12px;
  line-height: 1.25;
}

.neuron-selected-box {
  padding: 16px;
  border-radius: 18px;
  background: linear-gradient(135deg, rgba(30, 41, 59, 0.68), rgba(15, 23, 42, 0.72));
  border: 1px solid rgba(148, 163, 184, 0.2);
}

.neuron-selected-head {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.neuron-selected-head strong {
  display: block;
  font-size: 15px;
  color: #ffffff;
  margin-bottom: 4px;
}

.neuron-selected-head p,
.neuron-selected-meta p {
  margin: 5px 0 0;
  color: #cbd5e1;
  line-height: 1.48;
}

.neuron-selected-meta {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;
  margin-top: 20px;
}

.neuron-selected-meta h4 {
  margin: 0 0 8px;
  font-size: 13px;
  color: #ffffff;
}

.neuron-selected-meta span {
  display: inline-flex;
  padding: 7px 13px;
  border-radius: 999px;
  color: #fed7aa;
  background: rgba(251, 146, 60, 0.18);
  font-weight: 950;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

.neuron-side-card.raw ul {
  margin: 0;
  padding-left: 18px;
  color: #cbd5e1;
  line-height: 1.58;
  max-height: 280px;
  overflow: auto;
}

.neuron-side-card.raw p {
  color: #cbd5e1;
}

@media (max-width: 1180px) {
  .neuron-map-page {
    grid-template-columns: 1fr;
  }

  .neuron-canvas-shell {
    height: 640px;
  }

  .neuron-region-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 680px) {
  .neuron-map-page {
    padding: 14px;
    border-radius: 22px;
    min-height: auto;
  }

  .neuron-map-header {
    flex-direction: column;
  }

  .neuron-map-header h2 {
    font-size: 24px;
  }

  .neuron-help {
    display: none;
  }

  .neuron-canvas-shell {
    height: 440px;
    border-radius: 18px;
  }

  .neuron-region-grid {
    grid-template-columns: 1fr;
  }

  .neuron-selected-meta {
    grid-template-columns: 1fr;
  }

  .neuron-mode-toggle {
    width: 100%;
  }

  .neuron-mode-toggle button {
    flex: 1 1;
    padding-inline: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NeuronImpactMap.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB;;;kEAGgE;EAChE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,oFAAoF;EACpF,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qFAAqF;AACvF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB;;;WAGS;EACT,2CAA2C;EAC3C,oFAAoF;AACtF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,mFAAmF;EACnF,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,mFAAmF;EACnF,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mFAAmF;EACnF,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,oBAAoB;EACtB;AACF","sourcesContent":[".neuron-map-page {\n  width: 100%;\n  min-height: 860px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 420px;\n  gap: 22px;\n  padding: 20px;\n  border-radius: 28px;\n  color: #f8fafc;\n  overflow: hidden;\n  background:\n    radial-gradient(circle at 24% 28%, rgba(92, 72, 255, 0.24), transparent 28%),\n    radial-gradient(circle at 66% 44%, rgba(14, 165, 233, 0.12), transparent 26%),\n    linear-gradient(135deg, #050b18 0%, #081122 42%, #0d1628 100%);\n  border: 1px solid rgba(148, 163, 184, 0.18);\n  box-shadow: 0 30px 90px rgba(2, 6, 23, 0.28);\n}\n\n.neuron-main-panel {\n  min-width: 0;\n  position: relative;\n}\n\n.neuron-map-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.neuron-map-header h2 {\n  margin: 0;\n  font-size: 30px;\n  line-height: 1.05;\n  font-weight: 950;\n  letter-spacing: -0.04em;\n  color: #ffffff;\n  text-shadow: 0 0 28px rgba(255, 255, 255, 0.1);\n}\n\n.neuron-map-header p {\n  margin: 7px 0 0;\n  color: #cbd5e1;\n  font-size: 14px;\n}\n\n.neuron-help {\n  display: grid;\n  gap: 8px;\n  padding: 14px 16px;\n  border-radius: 16px;\n  background: rgba(15, 23, 42, 0.64);\n  border: 1px solid rgba(148, 163, 184, 0.24);\n  color: #cbd5e1;\n  font-size: 13px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 18px 42px rgba(0, 0, 0, 0.18);\n  backdrop-filter: blur(18px);\n}\n\n.neuron-mode-toggle {\n  display: inline-flex;\n  gap: 8px;\n  padding: 4px;\n  margin-top: 20px;\n  border-radius: 17px;\n  background: rgba(15, 23, 42, 0.72);\n  border: 1px solid rgba(148, 163, 184, 0.22);\n  box-shadow: 0 18px 55px rgba(0, 0, 0, 0.18);\n}\n\n.neuron-mode-toggle button {\n  border: 0;\n  border-radius: 13px;\n  padding: 12px 20px;\n  background: transparent;\n  color: #cbd5e1;\n  font-weight: 900;\n  cursor: pointer;\n  transition: transform 0.18s ease, background 0.18s ease, color 0.18s ease;\n}\n\n.neuron-mode-toggle button:hover {\n  transform: translateY(-1px);\n  color: #ffffff;\n}\n\n.neuron-mode-toggle button.active {\n  background: linear-gradient(135deg, #5b5ff7 0%, #7c3aed 100%);\n  color: #ffffff;\n  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.16), 0 14px 36px rgba(124, 58, 237, 0.42);\n}\n\n.neuron-canvas-shell {\n  height: 720px;\n  margin-top: 16px;\n  border-radius: 24px;\n  overflow: hidden;\n  background:\n    radial-gradient(circle at 50% 44%, rgba(77, 70, 229, 0.2), transparent 38%),\n    radial-gradient(circle at 75% 35%, rgba(14, 165, 233, 0.1), transparent 30%),\n    #020612;\n  border: 1px solid rgba(148, 163, 184, 0.18);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 22px 65px rgba(0, 0, 0, 0.28);\n}\n\n.neuron-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 14px;\n  padding: 12px 14px;\n  border-radius: 16px;\n  background: rgba(15, 23, 42, 0.72);\n  border: 1px solid rgba(148, 163, 184, 0.22);\n  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.16);\n}\n\n.neuron-legend button {\n  border: 0;\n  background: transparent;\n  color: #e5e7eb;\n  font-weight: 800;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 2px 0;\n}\n\n.neuron-legend i,\n.neuron-region-grid i,\n.neuron-selected-head i {\n  width: 14px;\n  height: 14px;\n  display: inline-block;\n  border-radius: 999px;\n  box-shadow: 0 0 18px currentColor, 0 0 30px currentColor;\n  flex: 0 0 auto;\n}\n\n.neuron-side-panel {\n  min-width: 0;\n  display: grid;\n  gap: 16px;\n  align-content: start;\n}\n\n.neuron-side-card {\n  padding: 18px;\n  border-radius: 22px;\n  background: rgba(15, 23, 42, 0.72);\n  border: 1px solid rgba(148, 163, 184, 0.22);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 24px 70px rgba(0, 0, 0, 0.2);\n  backdrop-filter: blur(20px);\n}\n\n.neuron-side-card h3 {\n  margin: 0 0 14px;\n  font-size: 17px;\n  font-weight: 950;\n  color: #ffffff;\n  letter-spacing: -0.02em;\n}\n\n.neuron-region-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.neuron-region-grid button {\n  text-align: left;\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  background: linear-gradient(135deg, rgba(30, 41, 59, 0.78), rgba(15, 23, 42, 0.72));\n  color: #f8fafc;\n  border-radius: 14px;\n  padding: 12px;\n  cursor: pointer;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  column-gap: 9px;\n  row-gap: 3px;\n  align-items: center;\n  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.neuron-region-grid button:hover {\n  transform: translateY(-1px);\n  border-color: rgba(226, 232, 240, 0.34);\n}\n\n.neuron-region-grid button.active {\n  border-color: rgba(124, 58, 237, 0.96);\n  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.16), 0 0 34px rgba(124, 58, 237, 0.18);\n}\n\n.neuron-region-grid strong {\n  font-size: 13px;\n  color: #ffffff;\n}\n\n.neuron-region-grid span {\n  grid-column: 2;\n  color: #cbd5e1;\n  font-size: 12px;\n  line-height: 1.25;\n}\n\n.neuron-selected-box {\n  padding: 16px;\n  border-radius: 18px;\n  background: linear-gradient(135deg, rgba(30, 41, 59, 0.68), rgba(15, 23, 42, 0.72));\n  border: 1px solid rgba(148, 163, 184, 0.2);\n}\n\n.neuron-selected-head {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.neuron-selected-head strong {\n  display: block;\n  font-size: 15px;\n  color: #ffffff;\n  margin-bottom: 4px;\n}\n\n.neuron-selected-head p,\n.neuron-selected-meta p {\n  margin: 5px 0 0;\n  color: #cbd5e1;\n  line-height: 1.48;\n}\n\n.neuron-selected-meta {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 16px;\n  margin-top: 20px;\n}\n\n.neuron-selected-meta h4 {\n  margin: 0 0 8px;\n  font-size: 13px;\n  color: #ffffff;\n}\n\n.neuron-selected-meta span {\n  display: inline-flex;\n  padding: 7px 13px;\n  border-radius: 999px;\n  color: #fed7aa;\n  background: rgba(251, 146, 60, 0.18);\n  font-weight: 950;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);\n}\n\n.neuron-side-card.raw ul {\n  margin: 0;\n  padding-left: 18px;\n  color: #cbd5e1;\n  line-height: 1.58;\n  max-height: 280px;\n  overflow: auto;\n}\n\n.neuron-side-card.raw p {\n  color: #cbd5e1;\n}\n\n@media (max-width: 1180px) {\n  .neuron-map-page {\n    grid-template-columns: 1fr;\n  }\n\n  .neuron-canvas-shell {\n    height: 640px;\n  }\n\n  .neuron-region-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 680px) {\n  .neuron-map-page {\n    padding: 14px;\n    border-radius: 22px;\n    min-height: auto;\n  }\n\n  .neuron-map-header {\n    flex-direction: column;\n  }\n\n  .neuron-map-header h2 {\n    font-size: 24px;\n  }\n\n  .neuron-help {\n    display: none;\n  }\n\n  .neuron-canvas-shell {\n    height: 440px;\n    border-radius: 18px;\n  }\n\n  .neuron-region-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .neuron-selected-meta {\n    grid-template-columns: 1fr;\n  }\n\n  .neuron-mode-toggle {\n    width: 100%;\n  }\n\n  .neuron-mode-toggle button {\n    flex: 1;\n    padding-inline: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
